import { v4 as uuidv4 } from "uuid";
import type {
  PaintImageReference,
  PaintReferenceImageRequest,
} from "@/types/paint-reference";

export const createPaintClientRequestId = () => `web-${uuidv4()}`;

export const createReferenceClientId = () => `ref-${uuidv4()}`;

export const normalizePaintReferences = (
  references: PaintImageReference[],
  maxCount: number,
): PaintImageReference[] => {
  const identities = new Set<string>();
  let hasPrimary = false;

  return references
    .filter((item) => {
      const identity =
        item.sourceType === "UPLOAD"
          ? `UPLOAD:${item.uploadImageId || item.ossKey || item.clientId}`
          : `TASK_OUTPUT:${item.sourceOutputId || item.clientId}`;
      if (identities.has(identity)) return false;
      identities.add(identity);
      if (item.role === "PRIMARY") {
        if (hasPrimary) return false;
        hasPrimary = true;
      }
      return true;
    })
    .slice(0, Math.max(0, maxCount))
    .map((item, sortNo) => ({ ...item, sortNo }));
};

export const toPaintReferenceRequests = (
  references: PaintImageReference[],
): PaintReferenceImageRequest[] =>
  references.map((item, sortNo) => ({
    sourceType: item.sourceType,
    ...(item.sourceType === "UPLOAD"
      ? { uploadImageId: item.uploadImageId }
      : { sourceOutputId: item.sourceOutputId }),
    role: item.role,
    sortNo,
  }));

export const getPaintReferenceIdentity = (item: PaintImageReference) =>
  item.sourceType === "UPLOAD"
    ? `UPLOAD:${item.uploadImageId || item.ossKey || item.clientId}`
    : `TASK_OUTPUT:${item.sourceOutputId || item.clientId}`;
